import z from 'zod'
import { TabRoutes } from '../../app/navigation/tab-routes'

const tabRoutesSchema = z.enum([
  TabRoutes.homeScreen,
  TabRoutes.playScreen,
  TabRoutes.learningScreen,
  TabRoutes.readScreen,
  TabRoutes.profileScreen,
  TabRoutes.membershipScreen
])

const tabNavConfigSchemaBase = z
  .object({
    enabledTabs: z.record(tabRoutesSchema, z.boolean()),
    initialRoute: tabRoutesSchema
  })
  .refine(
    (data) => {
      // initialRoute must be one of the enabled tabs
      const enabledTabs = Object.keys(data.enabledTabs).filter(
        (key) => data.enabledTabs[key as z.infer<typeof tabRoutesSchema>]
      )
      return enabledTabs.includes(data.initialRoute)
    },
    {
      message: 'initialRoute must be one of the enabled tabs'
    }
  )

export const tabNavConfigSchema = tabNavConfigSchemaBase.default({
  enabledTabs: {
    homeScreen: false,
    learningScreen: false,
    readScreen: false,
    playScreen: true,
    profileScreen: false,
    membershipScreen: false
  },
  initialRoute: TabRoutes.playScreen
})

/** examples:
 * {  "enabledTabs": {    "homeScreen": true,    "learningScreen": true,    "playScreen": true,    "profileScreen": true  },  "initialRoute": "homeScreen"}
 * {  "enabledTabs": {    "homeScreen": false,    "learningScreen": false,    "playScreen": true,    "profileScreen": false  },  "initialRoute": "playScreen"}
 */
